<template>
  <div class="min-h-screen bg-secondary-950 text-white flex flex-col font-sans selection:bg-primary-500 selection:text-white">
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useSettingsStore } from '@/store/modules/settings'

const settingsStore = useSettingsStore()

onMounted(() => {
  settingsStore.fetchSettings()
})
</script>

